module.exports = __webpack_public_path__ + "static/img/蒙版组 33.7f8802a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/蒙版组 33.png
// module id = O1pk
// module chunks = 0